function getInitials(name: any) {
  if (!name) return "-";
  const nameParts = name?.trim().split(" ");

  if (nameParts?.length === 1) {
    return nameParts[0][0].toUpperCase() + nameParts[0][0].toUpperCase();
  }

  const firstInitial = nameParts[0][0].toUpperCase();
  const lastInitial = nameParts[nameParts?.length - 1][0].toUpperCase();

  return firstInitial + lastInitial;
}

export default getInitials